import $ from "@modules/jquery";

export default () => {
    $('.leftImageTitleTextAccordionBlock .accordion-head').each((i, el) => {
        $(el).on('click', () => {
            const accordion = $(el).parent();
            const body = $(el).next('.accordion-body');
            if ($(accordion).hasClass('active')) {
                $(accordion).removeClass('active');
                $(body).slideUp(300);
                console.log("remove class");
            } else {
                $(accordion).addClass('active');
                $(body).slideDown(300);
                console.log("add class");
            }
        })
    });
}